import { render, staticRenderFns } from "./matchStatus.vue?vue&type=template&id=baf9dcbc&scoped=true&"
import script from "./matchStatus.vue?vue&type=script&lang=js&"
export * from "./matchStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf9dcbc",
  null
  
)

export default component.exports